import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  generateArticleUrl,
  imageResizeBaseUrl,
  getProp,
} from './../../ui/src/utilities';
import { StandardArticle } from './../../ui/src/component/article';
import { CsmArticle } from './../../ui/src/component/csmArticle';
import { Pill } from '../../ui/src/component/pill';
import { CsmSectionLink } from './../../ui/src/component/csmSectionLink';
import { CsmArticlePanorama } from './../../ui/src/component/csmArticlePanorama';
import { Spinner } from './../../ui/src/component/spinner';
import RelatedArticlesBanner from './relatedArticlesBanner';
import { Helmet } from 'react-helmet';

class ArticleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { preview } = this.props;
    let article = this.props.articles.byId[this.props.id];
    if (this.props.article) {
      article = {
        path: [],
        content: this.props.article,
      };
    }
    if (!article) {
      return <Spinner show={true} />;
    }

    const content = article.content;
    const relatedArticles = this.props.detail.related.articles;

    // Zobrazenie piluliek v headeri clanku
    let pills = [];
    pills = [
      ...pills,
      ...getProp(article, 'path', [])
        .filter((item, idx) => idx > 0)
        .map(item => {
          return (
            <CsmSectionLink key={item._id} section={item}>
              <Pill content={item.name} />
            </CsmSectionLink>
          );
        }),
    ];

    let mainImage = '';
    let widgets = getProp(content, 'widgets', []);
    for (let widget of widgets) {
      if (widget.type === 'photo') {
        mainImage = `${imageResizeBaseUrl(1000)}/${widget.uri}`;
        break;
      }
    }

    const canonicalUrl = `${process.env.REACT_APP_BASE_URL}${generateArticleUrl(
      article.content,
    )}`;
    return (
      <div>
        <Helmet>
          <title>{content.name}</title>
          {!preview && <meta property="og:title" content={content.name} />}
          {!preview && <meta property="og:type" content="article" />}
          {!preview && <meta property="og:url" content={canonicalUrl} />}
          {!preview && mainImage && (
            <meta property="og:image" content={mainImage} />
          )}
          {!preview && (
            <meta property="og:description" content={content.perex} />
          )}
        </Helmet>
        <a name="article-content">{null}</a>
        <CsmArticlePanorama article={content} pills={pills} />
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-9">
              <CsmArticle content={content} preview={preview} />
            </div>
            {relatedArticles.length > 0 && (
              <div className="col-sm-12 col-md-3">
                <RelatedArticlesBanner />
                <h3>Podobné články</h3>
                <div className="row">
                  {relatedArticles.map(item => {
                    return (
                      <div
                        key={item._id}
                        className="col-xs-12 col-sm-6 col-md-12"
                      >
                        <StandardArticle article={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ArticleDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  articles: PropTypes.object.isRequired,
  detail: PropTypes.object.isRequired,
  id: PropTypes.number,
  article: PropTypes.object,
  preview: PropTypes.bool,
};

ArticleDetail.defaultProps = {
  preview: false,
};

export default connect(state => {
  return {
    articles: state.articles,
    detail: state.articleDetail,
  };
})(ArticleDetail);



// WEBPACK FOOTER //
// ./src/app/container/articleDetail.js